import { combineReducers } from 'redux';

import journals from './journals';
import resources from './resources';
import scholars from './scholars';
import departments from './departments';
import code from './code';
import category from './category';
import footer from "./footer";
export default combineReducers({
    journals,
    resources,
    scholars,
    departments,
    code,
    category,
    footer
});
